import { useLoadApplications, useLoadCourses } from '~/modules/applications/models/application.hooks';

export const ApplicationsModule = () => {
  useLoadCourses();
  useLoadApplications();
  return <></>;
};
